export const COMPANY = {
  name: "MOVIX",
  fullName: "Movix Car Rental",
  tagline: "CAR RENTAL",
  phone: "(561) 455-6277",
  email: "movixcarrental@gmail.com",
  address: "70 Chelsea St, Everett, MA",
  brandColor: "#F5A623",
  brandColorDark: "#D97706",
  brandColorBg: "#0A0A0A",
};
